document.addEventListener('DOMContentLoaded', function () {
  const progressBar = document.getElementById('scroll-progress-bar');
  const article = document.querySelector('.article-template');

  function updateProgress() {
    const articleTop = article.offsetTop;
    const articleHeight = article.offsetHeight;
    const scrollTop = window.scrollY;
    const windowHeight = window.innerHeight;

    const start = articleTop;
    const end = articleTop + articleHeight - windowHeight;

    if (scrollTop <= start) {
      progressBar.style.width = '0%';
    } else if (scrollTop >= end) {
      progressBar.style.width = '100%';
    } else {
      const percent = ((scrollTop - start) / (end - start)) * 100;
      progressBar.style.width = percent + '%';
    }
  }

  window.addEventListener('scroll', updateProgress);
  window.addEventListener('resize', updateProgress);
  updateProgress(); // inizializza alla prima visualizzazione
});
